<template>
  <div>
    <div class="innerBox filter">

      <div class="d-flex flex-row justify-content-between">
        <div>
          <h2 class="page-title">Holiday</h2>
        </div>
        <div class="d-flex flex-row justify-content-end">
          <div class="mr-3">
            <div class="input-group" style="min-width: 260px;">
                <flat-pickr 
                    :config="rangePickr" 
                    placeholder="Select Date" 
                    v-model="selected.date"></flat-pickr>
                <div class="input-group-append">
                    <span class="input-group-text bg-white border-left-0" 
                            style=" border-top-right-radius: 5px; 
                                    border-bottom-right-radius: 5px; 
                                    border: 0; 
                                    box-shadow: 0 0 6px #0000000F; 
                                    background-color: #EDEDED !important;">
                        <i class="fas fa-calendar" style="color: black;"></i>
                    </span>
                </div>
            </div>
          </div>
          <a href="" class="btn" style="    margin-right: -1rem !important;
    padding: 0;">
            <img src="@/assets/img/notification.svg" alt="" style="display: none;">
          </a>
        </div>
      </div>
    </div>
    <div class="bg-white shadow box-content mt-5">
      <vue-universal-table
        api_url="/api/holiday/list"
        :filter="filter"
        :indexing=true
        :buttons="vue_universal_table.buttons"
        :fields="vue_universal_table.fields"
        :update="vue_universal_table.update"
        @onEdit="editHoliday"
      />
    </div>
    <ModalHoliday 
      v-if="modal.edit" 
      @closeModal="modal.edit = false"
      @refreshData="vue_universal_table.update++"
      :data="modal.editData"
    />
  </div>
</template>
<script>
import moment from "moment";
import debounce from "debounce";
import ModalHoliday from './ModalHoliday.vue';
import "flatpickr/dist/flatpickr.css";

export default {
  metaInfo: {
    title: 'Holiday'
  },
  data() {
    let startDate = moment().startOf('year').format('YYYY-MM-DD');
    let endDate = moment().endOf('year').format('YYYY-MM-DD');
    return {
      rangePickr: {
        mode: 'range',
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d M Y",
        altInputClass: 'form-control input grey-flatpickr'
      },
      selected: {
        date: `${startDate} to ${endDate}`
      },
      modal: {
        edit: false,
        editData: null
      },
      filter: {
        start: startDate,
        end: endDate
      },
      vue_universal_table: {
        fields: [
          {title: "Tanggal", variable: "column_date", disable_sort: true},
          {title: "Status", variable: "status", disable_sort: true}
        ],
        buttons: [
          {
            title: "Edit",
            variable: null,
            class: "fas fa-edit btn-secondary rounded-button"
          }
        ],
        update: 0
      }
    }
  },
  components: {
    ModalHoliday
  },
  watch: {
    'selected.date' () {
      let split = this.selected.date.split(" to ");
      this.filter.start = split[0];
      this.filter.end = split.length > 1 ? split[1] : split[0];
    },
    'filter': {
      deep: true,
      immediate: true,
      handler: 'updateData'
    }
  },
  methods: {
    updateData: debounce(function() {
        this.vue_universal_table.update++;
    }, 1000),
    editHoliday(holiday) { 
      this.modal.editData = holiday;
      this.modal.edit = true;
    }
  }
}
</script>
<style scoped>
.box-content {
    padding: 20px;
    border-radius: 10px;
}

.align-middle {
    display: flex;
    align-items: center;
}

.page-title {
    font-size: 27px;
    font-weight: bold;
    margin: 0;
}

.innerBox {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 3px 10px #0000000f;
    padding: 20px;
}

.chart {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 3px 10px #0000000f;
    padding: 20px;
    align-items: center;
}

.elegant--sub-title {
    font-size: 18px;
    font-weight: 500;
    color: #9f9f9f;
}

.stats--icon {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.table td,
.table th {
    text-align: center;
}

.news-image-1 img {
    max-width: 100%; /* To make the image smaller and responsive */
}

.news-title-1 {
    text-align: left; /* To position the news-title on the top right */
}

.news-content-1 {
    text-align: left; /* To position the news-content on the bottom right */
}

/* tms-table start */
.tms-table {
    width: 100%;
    border-collapse: collapse;
}

.tms-table th,
.tms-table td {
    padding: 8px;
    text-align: left;
    vertical-align: middle;
}

/* Styling for table headers */
.tms-table th {
    color: #bcbcbc;
    font-weight: normal;
    border-bottom: 0px solid #e4e7ea;
}

/* Styling for table data cells */
.tms-table td {
    font-weight: normal;
}

/* Remove top border from first row */
.tms-table tr:first-child td {
    border-top: none;
}
/* tms-table end */
</style>
